import React from 'react'
import SME from '../components/Sme/Sme'

const Sme = () => {
    return <SME />
}

export default Sme
